import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApiService } from './base-api.service';
import {
    ThermalMethodApiModel,
    SystemThermalMethodMappingApiModel,
    ThermalRefactorModel,
    GermanUfEquationFacadeApiModel,
    GermanUfEquationWindowApiModel,
    GermanUfValuesSlidingDoorApiModel,
    GermanUfValuesWindowApiModel,
    FrenchUfValuesWindowApiModel
} from '../models';

/**
 * Thermal Refactor API Service
 */
@Injectable({
    providedIn: 'root'
})
export class ThermalService extends BaseApiService {

    /**
     * Get thermal methods
     */
    getThermalMethods(): Observable<ThermalMethodApiModel[]> {
        return this.get<ThermalMethodApiModel[]>('/thermal-refactor/methods')
            .pipe(map(response => response.data!));
    }

    /**
     * Get system thermal method mappings
     */
    getSystemThermalMethodMappings(): Observable<SystemThermalMethodMappingApiModel[]> {
        return this.get<SystemThermalMethodMappingApiModel[]>('/thermal-refactor/system-mappings')
            .pipe(map(response => response.data!));
    }

    /**
     * Get thermal refactor data
     */
    getThermalRefactorData(): Observable<ThermalRefactorModel[]> {
        return this.get<ThermalRefactorModel[]>('/thermal-refactor/data')
            .pipe(map(response => response.data!));
    }

    /**
     * Get German Uf equation facade data
     */
    getGermanUfEquationFacade(): Observable<GermanUfEquationFacadeApiModel[]> {
        return this.get<GermanUfEquationFacadeApiModel[]>('/thermal-refactor/german-uf-equation-facade')
            .pipe(map(response => response.data!));
    }

    /**
     * Get German Uf equation window data
     */
    getGermanUfEquationWindow(): Observable<GermanUfEquationWindowApiModel[]> {
        return this.get<GermanUfEquationWindowApiModel[]>('/thermal-refactor/german-uf-equation-window')
            .pipe(map(response => response.data!));
    }

    /**
     * Get German Uf values sliding door data
     */
    getGermanUfValuesSlidingDoor(): Observable<GermanUfValuesSlidingDoorApiModel[]> {
        return this.get<GermanUfValuesSlidingDoorApiModel[]>('/thermal-refactor/german-uf-values-sliding-door')
            .pipe(map(response => response.data!));
    }

    /**
     * Get German Uf values window data
     */
    getGermanUfValuesWindow(): Observable<GermanUfValuesWindowApiModel[]> {
        return this.get<GermanUfValuesWindowApiModel[]>('/thermal-refactor/german-uf-values-window')
            .pipe(map(response => response.data!));
    }

    /**
     * Get French Uf values window data
     */
    getFrenchUfValuesWindow(): Observable<FrenchUfValuesWindowApiModel[]> {
        return this.get<FrenchUfValuesWindowApiModel[]>('/thermal-refactor/french-uf-values-window')
            .pipe(map(response => response.data!));
    }
}
